import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export type AccessCard = {
  id: number;
  renter_id: number | null;
  owner_id: number;
  user_id: number;
  card_uid: string;
  issuer_type: "BUSINESS" | "RENTER";
};

export type AccessCardCreate = {
  device_id: number;
  renter_id: number | null;
  owner_id: number;
  user_id: number;
  issuer_type: "BUSINESS" | "RENTER";
};

export const AccessCardsAPI = (baseUrl: string) => {
  return {
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/access-cards/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<AccessCard[]>;
    },
    create: async (accessCardData: AccessCardCreate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/access-cards?business_profile_id=${businessProfileId}`,
        accessCardData,
        true,
      )) as ApiResponse<unknown>;
    },
    delete: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/access-cards/${id}?business_profile_id=${businessProfileId}`,
        true,
      )) as ApiResponse<unknown>;
    },
  };
};
